let isAtTop = false;

const fixedFacets = document.getElementById("fixed-facets");
document.addEventListener("scroll", function () {
  if (fixedFacets) {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop >= 1 && !isAtTop) {
      isAtTop = true;
      fixedFacets.classList.add("fixed");
    } else if (scrollTop < 1 && isAtTop) {
      isAtTop = false;
      fixedFacets.classList.remove("fixed");
    }
  }
});

// Role: Style header when search modal opens, and restore to default styling when closed, across devices

const header = document.getElementById("shopify-section-header");
const headerSearchButton = document.body.querySelector(".btn.search__mobile");

// State
function getSearchModalState() {
  const searchModal = document.querySelector(".search-modal");
  return {
    isOpen: searchModal?.classList.contains("is-open"),
    isDesktop: window.innerWidth > 1024,
    titleAndFilters: document.body.querySelector(".title_and_filters"),
  };
}

function getScrollPosition() {
  return window.scrollY || document.documentElement.scrollTop;
}

function getAnnouncementBarOffset() {
  const bar = document.querySelector(
    "#shopify-section-announcement-bar .announcement-bar"
  );
  return parseFloat(bar?.dataset.offsetTop || 0);
}

//  Actions
function hideFacetsForSearch() {
  const { titleAndFilters } = getSearchModalState();
  if (fixedFacets) {
    fixedFacets.style.display = "none";
  }
  if (header) {
    header.style.minHeight = "";
  }
  if (titleAndFilters) {
    titleAndFilters.style.display = "none";
  }
}

function restoreFacetsAfterSearch() {
  const { titleAndFilters, isDesktop } = getSearchModalState();
  if (fixedFacets) {
    fixedFacets.style.display = "";
    fixedFacets.style.zIndex = "";
  }
  if (header) {
    header.removeAttribute("style");
  }
  if (titleAndFilters) {
    titleAndFilters.style.display = "";
  }

  if (!isDesktop && header) {
    header.style.height = "56px";
    if (fixedFacets) {
      fixedFacets.style.height = "32px";
    }
  }
}

function removeFixedHeaderIfAtTop() {
  if (getScrollPosition() < getAnnouncementBarOffset()) {
    document.querySelector(".main_header")?.classList.remove("fixed-header");
    document
      .querySelector("#shopify-section-announcement-bar")
      ?.classList.remove("fixed-ab");
  }
}

// Event listeners for native search modal
if (headerSearchButton) {
  headerSearchButton.addEventListener("click", () => {
    hideFacetsForSearch();
  });
}

// Listen for custom search modal events
document.addEventListener("search-modal:open", () => {
  hideFacetsForSearch();
});

document.addEventListener("search-modal:close", () => {
  removeFixedHeaderIfAtTop();
  restoreFacetsAfterSearch();
});

if (header) {
  header.addEventListener("mouseover", () => {
    const state = getSearchModalState();
    if (state.isOpen) hideFacetsForSearch();
    if (fixedFacets) {
      fixedFacets.style.zIndex = "100";
    }
  });

  header.addEventListener("mouseout", () => {
    const state = getSearchModalState();
    if (header) {
      header.removeAttribute("style");
    }
    if (!state.isOpen) restoreFacetsAfterSearch();
  });
}
